/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aroma_CreatedInputs */

const en_aroma_created = /** @type {(inputs: Aroma_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aroma created`)
};

const es_aroma_created = /** @type {(inputs: Aroma_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aroma creado`)
};

/**
* | output |
* | --- |
* | "Aroma created" |
*
* @param {Aroma_CreatedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const aroma_created = /** @type {((inputs?: Aroma_CreatedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aroma_CreatedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aroma_created(inputs)
	return es_aroma_created(inputs)
});